<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col><v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon></v-col>
            </v-row>
            <!--<v-container>
                <v-row>
                    <v-col md="6" cols="12">-->
                        <!-- Filter by Year -->
                        <!--<v-menu v-model="yearMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field hide-details v-model="selectedYear" outlined clearable dense
                                              :label="$t('Year')"
                                              readonly
                                              v-bind="attrs" @input="selectYear($event)"
                                              v-on="on"></v-text-field>
                            </template>
                            <v-date-picker :max="maxDate"
                                           type="year" @click:year="selectYear($event)"></v-date-picker>
                        </v-menu>

                    </v-col>
                    <v-col md="6" cols="12">-->
                        <!-- Filter by Quarter (using Calendar) -->
                        <!--<v-select hide-details v-model="selectedQuarter" @input="selectQuarter($event)" clearable outlined dense
                                  :items="quarters"
                                  :label="$t('Quarter')"></v-select>
                    </v-col>
                </v-row>
            </v-container>-->
            <v-dialog v-model="dialog" persistent max-width="500px">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="4" v-for="(item, index) in value"
                                   :key="index">
                                <v-color-picker v-model="item.color"
                                                mode="hexa"></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-row v-if="selectedChart === 'chart4'">
                <v-col>
                    <v-row class="d-flex align-center justify-space-between " style="background-color: #efeded; border-radius: 8px;">
                        <v-col cols="auto" style="position:relative">

                            <div :style="'position:absolute;right:10px;top:190px;width:100px;height:201px;background-image:url(/satisfactionbackground.png);background-size:contain;background-repeat:no-repeat;background-position:top center'">
                                <table style="width:100%">
                                    <tr>
                                        <td style="text-align:center;font-size:12px;color:white;padding-top:20px"><img src="/satisfactionstars.png" style="margin:auto" /><br />{{$t('OverAllSAtisfaction')}}</td>
                                    </tr>
                                    <tr><td style="font-weight: 700; padding-top: 40px; text-align: center; font-size: 25px; color: #5EBFCE">{{publicsatisfactoryPerc}}%</td></tr>
                                </table>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- Satisfaction Table -->
                        <v-col cols="2">
                        </v-col>
                        <!-- Satisfaction Levels with Vertical Bars -->
                        <v-col cols="10" class="d-flex justify-center">
                            <v-row>
                                <v-col v-for="(item, index) in value"
                                       :key="index"
                                       class="text-center d-flex flex-column align-center" cols="4" md="2" @click="filterQuestionOption(item)">
                                    <img :src="`face${item.name}.png`" style="width:50px" /><br />
                                    <div style="font-size: 21px; color: #000;">{{ item.percentage }}%</div>
                                    <div class="bar-container chart4 d-flex flex-column justify-end">
                                        <div class="bar"
                                             :style="{
                                                      height: `${item.percentage}%`,
                                                      backgroundColor: item.color
                                                    }">
                                            <!--<table style="height: 100%; margin-top: -10px; width: 100%; font-weight: bold; font-size: 21px;"><tr><td valign="middle"><span>{{ item.percentage }}%</span></td></tr></table>-->
                                        </div>
                                    </div>
                                    <div class="mt-2" style="font-size: 21px; color: #000;">{{ item.level }}</div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            quarters: {
                type: Array,
                default: () => [],
            },
            q: undefined,

        },
        data() {
            return {
                selectedChart: 'chart4', // Default to horizontal view
                dialog:false,
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                maxDate: new Date().toISOString().split('T')[0],
            }
        },
        computed: {
            publicsatisfactoryPerc() {

                var five = this.value.filter(x => x.name == '5')
                var four = this.value.filter(x => x.name == '4')

                var satisfactory = 0
                if (five.length > 0)
                    satisfactory += five[0].percentage
                if (four.length > 0)
                    satisfactory += four[0].percentage
                return satisfactory
            },
            publicsatisfactoryTotal() {
                var satisfactory = 0
                for (var i = 0; i < this.value.length; i++) {
                    satisfactory += this.value[i].count
                }
                return satisfactory
            }

        },
        methods: {
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
                this.$emit('selectCSATFiveYear', year)
            },
            selectQuarter(quarter) {
                this.$emit('selectCSATFiveQuarter', quarter)
            },
            filterQuestionOption(item) {
                this.$emit('filterQuestionOption', item, this.q, this.value)
            }
        }
    }
</script>

<style scoped>
    .text-center {
        text-align: center;
    }

    .text-right {
        text-align: right;
    }

    .text-caption {
        font-weight: bold;
        background-color: #eef0f2;
        padding: 5px;
        border-radius: 5px;
    }

    .bar-container {
        height: 150px;
        width: 30px;
        background-color: #eef0f2;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-radius: 4px;
    }

    .bar {
        width: 100%;
        border-radius: 4px;
    }

    .chart3 {
        width: 50px;
        height: 300px;
        position: relative
    }

    .chart4 {
        width: 100%;
        height: 200px;
        position: relative;
        border-radius: 20px;
        border: 5px solid white;
    }

        .chart4 .bar {
            border-radius: 10px;
        }

    .d-flex {
        display: flex;
    }

    .align-center {
        align-items: center;
    }

    .flex-column {
        flex-direction: column;
    }

    .rotated-text {
        display: inline-block; /* Ensures the rotation works properly */
        transform: rotate(270deg); /* Rotates text by 45 degrees */
        transform-origin: center; /* Sets the point around which the text is rotated */
        position: absolute;
        bottom: 100px;
        width: 280px;
        font-weight: 700
    }
</style>
